import GoalActions from '../../actions/GoalActions';
import PublisherActions from '../../actions/PublisherActions';
import AppConstants from '../../constants/AppConstants';
import store from '../../stores/redux';

const { dispatch } = store;
const count = 50;
const events = {
    fail: AppConstants.SELECT_GOAL_ACTIONS_FAIL
};

const actions = {
    beforeLoading(downloadType) {
        dispatch({
            type: AppConstants.SELECT_GOAL_ACTIONS_START_LOADING,
            downloadType
        });
    },

    successUpload(downloadType, data) {
        dispatch({
            type: AppConstants.SELECT_GOAL_ACTIONS_SUCCESS,
            downloadType,
            items: data
        });
    },

    getListOffers() {
        actions.beforeLoading('offers');

        PublisherActions.getOffers({
            count
        }, data => {
            actions.successUpload('offers', data);
        }, events);
    },

    getListGoals(params) {
        actions.beforeLoading('goals');

        PublisherActions.getGoals({
            ids: params.ids,
            offer_ids: params.offerIds,
            count
        }, data => {
            actions.successUpload('goals', data);
        }, events);
    },

    getListGoalActions(params) {
        actions.beforeLoading('goalActions');

        GoalActions.getListGoalActions({
            ids: params.ids,
            goal_ids: params.goalIds,
            count
        }, data => {
            actions.successUpload('goalActions', data);
        }, events);
    }
};

export default actions;
